module.exports = __webpack_public_path__ + "img/stock1.5f1815a7.png";